import { createContext, useContext } from "react";
import Subjects from "../models/subjects";
import AuthStore from './common/auth-store';
import { SubjectContainer } from "./subject-container-store";
import FilesService from "../services/files-service";

export class RootStore {

    authStore: AuthStore;
    fileService: FilesService;
    subjectStores: { [key in Subjects]: SubjectContainer };

    constructor() {
        
        this.authStore = new AuthStore();
        this.fileService = new FilesService();

        // Initialize subject stores dictionary
        this.subjectStores = {
            [Subjects.MATH]: new SubjectContainer(Subjects.MATH),
            [Subjects.PHYSIC]: new SubjectContainer(Subjects.PHYSIC)
        };
    }
}

export const RootStoreContext = createContext<RootStore | null>(null);

export const useStore = () => {

  const context = useContext(RootStoreContext);
  if (context === null) {
    throw new Error(
      "You have forgotten to wrap your root component with RootStoreProvider"
    );
  }
  return context;
};